import { render, staticRenderFns } from "./NewPurchase.vue?vue&type=template&id=f4854396&"
import script from "./NewPurchase.vue?vue&type=script&lang=js&"
export * from "./NewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./NewPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports